import {  View, Modal,} from 'react-native-web'
import  {useState} from 'react'
import { CardModal} from '../../../../../element/Card'
import { AbilityBody, SubTitle, AbilityTitle } from '../../../../../element/Text'




const AbilityModal = props =>{
 const [modalv, setModalv]= useState(props.modalv)




    return(
        
        <Modal visible={modalv}
                transparent={true}
                animationType={'slide'}
                key={props.key}
                style={{width:'100%', height:'100%',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
                <View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}>
                    <CardModal hsize={'80%'} icon2={false} icon1={true} onPress={props.onPress}>
                        <View style={{width:'90%', height:'90%',padding:15, alignSelf:'center', alignItems:'center', backgroundColor:'#252525', borderRadius:16,shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, marginTop:15, marginBottom:15, borderColor:'#F9BA49', borderWidth:1.8}}>
                            <AbilityTitle color1={'#F9BA49'} value={'Nome: '+props.title}/>
                            <SubTitle color1={'#F9BA49'} value={'Tipo: '+props.type}/>
                            <AbilityTitle color1={'#F9BA49'} value={'Descrizione: '}/>
                            <View style={{marginTop:15, padding:15, alignSelf:'center', alignItems:'center', backgroundColor:'#303030', borderRadius:8,shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,borderColor:'#F9BA49', borderWidth:1.8}}>
                                <AbilityBody color1={'#F9BA49'} value={props.description} align={'flex-start'}/>
                            </View>
                                <AbilityTitle color1={'#F9BA49'} value={'Prerequisiti: '}/>
                            <View style={{marginTop:15,width:'90%', padding:15, alignSelf:'center', alignItems:'center', backgroundColor:'#303030', borderRadius:8, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, marginBottom:15, borderColor:'#F9BA49', borderWidth:1.8}}>
                                <AbilityBody color1={'#F9BA49'} value={props.prerequisite} align={'center'}/>
                            </View>
                        </View>
                    </CardModal>
                </View>
        </Modal>
           


    )
}

const ArcaneModal = props =>{
    const [modalv, setModalv]= useState(props.modalv)
   
   
   
   
       return(
           
           <Modal visible={modalv}
                   transparent={true}
                   animationType={'slide'}
                   key={props.key}
                   style={{width:'100%', height:'100%',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
                   <View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}>
                       <CardModal hsize={'80%'} icon2={false} icon1={true} onPress={props.onPress}>
                           <View style={{width:'90%', height:'90%',padding:15, alignSelf:'center', alignItems:'center', backgroundColor:'#252525', borderRadius:16,shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, marginTop:15, marginBottom:15, borderColor:'#F9BA49', borderWidth:1.8}}>
                               <AbilityTitle color1={'#F9BA49'} value={'Nome: '+props.title}/>
                               <SubTitle color1={'#F9BA49'} value={'Pilastro: '+props.erinni}/>
                               <AbilityTitle color1={'#F9BA49'} value={'Descrizione: '}/>
                               <View style={{marginTop:15, padding:15, alignSelf:'center', alignItems:'center', backgroundColor:'#303030', borderRadius:8,shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,borderColor:'#F9BA49', borderWidth:1.8}}>
                                   <AbilityBody color1={'#F9BA49'} value={props.description} align={'flex-start'}/>
                               </View>
                           </View>
                       </CardModal>
                   </View>
           </Modal>
              
   
   
       )
   }
export {AbilityModal, ArcaneModal}